// Build identifier derived from CRA's asset-manifest.json (the main bundle hash
// changes on every production build/deploy). Returns null in dev (no manifest).
export async function fetchBuildId() {
  try {
    const res = await fetch(`${process.env.PUBLIC_URL || ""}/asset-manifest.json`, { cache: "no-store" });
    if (!res.ok) return null;
    const data = await res.json();
    const main =
      (data.files && (data.files["main.js"] || data.files["main.css"])) ||
      (data.entrypoints && data.entrypoints.join(",")) ||
      JSON.stringify(data.files || {});
    return main || null;
  } catch {
    return null;
  }
}

// Short, human-readable build number extracted from the bundle hash.
export function shortBuildId(buildId) {
  if (!buildId) return "dev";
  const m = String(buildId).match(/main\.([a-f0-9]{6,})\./i);
  return m ? m[1].slice(0, 8) : "dev";
}
